// IMPORT REACT
import React from "react";
import Axios from "axios";

import NotFound from '../NotFound';
import Loading from '../Loading';

import Home from './Home';
import Faqs from './Faqs';
import Resources from './Resources';
import Login from './Login';
import TermsOfUse from './TermsOfUse';

const identifyComponent = (page) => {
  const components = {
    'home': Home,
    'faqs': Faqs,
    'resources': Resources,
    'login': Login,
    'terms-of-use': TermsOfUse,
    'privacy-policy': TermsOfUse,
  }
  return components[page.post_name_en];
}

class Page extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      lang: null,
      token: null,
      bloginfo: null,
      slug: this.getSlug(this.props.match),
      page: null
    };
  }

  componentDidMount() {
    this.getPageContent(this.state.slug);
  }

  componentDidUpdate(previousProps, previousState) {
    const slug = this.getSlug(this.props.match);
    const previousSlug = this.getSlug(previousProps.match);

    if (slug !== previousSlug) {
      this.getPageContent(slug);
    }
  }

  getSlug(match) {
    let slug = match.params.slug === 'undefined' ? match.path.replace(/\//g, '') : match.params.slug;
    if (match.params.resources) {
      slug = match.params.resources;
    }
    // typeof slug === 'undefined' ? slug = this.props.match.path.replace(/\//g, '') : slug = '';
    return typeof slug === 'undefined' || slug === '' ? slug = 'home' : slug = slug;
  }

  getPageContent(slug) {
    return this.getPage(slug).then(data => {
      if (data && data[0]) {
        this.setState({
          page: data[0],
          lang: data[0] ? data[0].lang : null
        }, function () {

        })
      } else {
        this.setState({
          page: '404'
        }, function () {

        })
      }
      this.getBloginfo(this.state.lang).then(data => {
        this.setState({
          bloginfo: data
        }, function () {

        })
      });
    });
  }

  getBloginfo(lang) {
    let url = '/wp-json/wp/v2/weemarkable/bloginfo/';
    url += '?lang=';
    url += lang;
    let self = this;
    return Axios({
      method: 'get',
      url: url
    }).then((response) => {
      return response.data;
    }).catch(function (error) {
      console.log(error, 'Error');
    });
  }

  getPage(page_name) {
    let url = '/wp-json/wp/v2/weemarkable/pages/';
    url += '?post_type=page&post_name=';
    url += page_name;
    let self = this;
    return Axios({
      method: 'get',
      url: url,
      headers: {
        // eslint-disable-next-line no-undef
        'X-WP-Nonce': frontend_ajax_object.nonce
      },
    }).then((response) => {
      if (response.data[0]) {
        return response.data;
      } else {
        console.log(response, 'Error');
      }
    }).catch(function (error) {
      console.log(error, 'Error');
    });
  }

  render() {
    const page = this.state.page;
    const bloginfo = this.state.bloginfo;
    const lang = this.state.lang;

    if (!bloginfo || !page) {
      return <Loading />;
    }

    if (bloginfo && page && page == '404') {
      return <NotFound />;
    }

    let Template = identifyComponent(page);

    return (
      <Template page={page} bloginfo={bloginfo} lang={lang} />
    );

  }
}

export default Page;